import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JEService } from 'src/app/services/je-services.service';

@Component({
  selector: 'app-mi-physical-location',
  templateUrl: './mi-physical-location.component.html',
  styleUrls: ['./mi-physical-location.component.scss']
})
export class MiPhysicalLocationComponent implements OnInit {
  public userId: any;
  public vendorRegId: any;
  public displaySourceLocationDialog: boolean = false;
  public rowData: any;
  public latPosition: any;
  public longPosition: any;
  public micada1Data: any;
  

  options: any;
  // overlays: any[];
  overlays: google.maps.Marker[] = [];
  showMap: boolean = false;
  showgeoLocation: boolean = false;

  selectedStatus: any;
  remarks: String;
  items: any[];

  actionId: any = 18;

  constructor(
    private jeService: JEService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.options = {
      center: { lat: 29.0588, lng: 76.0856 },
      zoom: 7,
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    this.loadData();
  }

  loadData() {
    const token: any = JSON.parse(sessionStorage.getItem('token'));
    console.log('token1', token);
    let payload = atob(token?.authToken?.split('.')[1]);
    console.log('payload1', JSON.parse(payload));
    this.userId = JSON.parse(payload)?.sub;
    this.vendorRegId = JSON.stringify(token?.officeCode);
    console.log('officeCode', this.vendorRegId);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);
    // console.log('payload', JSON.parse(payload))

     
    if(this.router.url.startsWith('/xen')){
      this.actionId = 18;
    }
    else if(this.router.url.startsWith('/department')){
      this.actionId = 2;
    }
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, this.actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          this.selectedStatus = this.items[0]?.status;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });

    this.loader.start();
    this.jeService
      .getMICADA1data(this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(
            this.userId,
            'MI Source Location',
            '',
            new Date(),
            'Success'
          );

          console.log('Response Data', data);
          this.userId = JSON.parse(payload)?.sub;
          if (data.length > 0) {
            this.micada1Data = data;
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(
            this.userId,
            'MI Source Location',
            '',
            new Date(),
            err
          );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onRowSelect(row) {
    console.log('row', row);
    this.rowData = row;
    if(row?.gpsCoordinate){
      let coordinates =  row?.gpsCoordinate.split(',')
      this.latPosition = parseFloat(coordinates[0].trim());
      this.longPosition = parseFloat(coordinates[1].trim());
      this.showgeoLocation = true;
      this.options = {
        center: { lat: this.latPosition, lng:  this.longPosition },
        zoom: 12,
        mapTypeId: google.maps.MapTypeId.SATELLITE
      };
      this.addOverlay(this.latPosition,  this.longPosition);
    }
    this.displaySourceLocationDialog = true;
  }

  onCloseDialog() {
    this.displaySourceLocationDialog = false;
    this.rowData = [];
    this.showgeoLocation = false;
    this.showMap = false;
    this.latPosition = null;
    this.longPosition = null;
    this.remarks = null;
  }

  submitFinalData() {
    let coordinates = this.latPosition + ', ' + this.longPosition;
    let reqBody = {
      app_id: this.rowData?.app_id,
      programmename: this.rowData?.programmename,
      name: this.rowData?.name,
      father_name: this.rowData?.father_name,
      mother_Name: this.rowData?.mother_Name,
      distict: this.rowData?.distict,
      block: this.rowData?.block,
      village: this.rowData?.village,
      gpsCoordinate: coordinates,
      remarks: this.remarks,
      userId: this.userId
    };

    this.loader.start();
    this.jeService
      .insertMISurveyCoordinates(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(
            this.userId,
            'Submit Approval',
            this.rowData?.app_id,
            new Date(),
            this.selectedStatus.status
          );
          let resp = JSON.stringify(data);
          if (data == "Data saved.") {
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: resp,
            });
            this.loadData();
            this.onCloseDialog();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: resp,
            });
          }
        },
      });
  }

  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
      this.showgeoLocation = true;
      this.options = {
        center: { lat: pos.lat, lng: pos.lng },
        zoom: 12,
      };
      this.addOverlay(pos.lat, pos.lng);
      console.log(this.latPosition, this.longPosition);
    });
  }

  _getPosition(): Promise<any> {
    this.loader.start();
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          this.loader.close();
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          this.loader.close();
          reject(err);
        }
      );
    });
  }

  addOverlay(latitide: any, longitude: any) {
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: latitide, lng: longitude },
        title: 'Current Location',
      })
    );
    this.showMap = true;
  }

  captureLocation(){
    this.getGPSCoordinates();
  }
}
